import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { easeOut } from "@/components/common/Reveal";
import { CENTRES } from "@/data/site";

export default function CentresPreview() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="centres-preview">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <SectionHeading
            eyebrow="Nos centres"
            title="Nos centres de formation"
          />
          <Link
            to="/nos-centres"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-red hover:underline"
            data-testid="centres-preview-all"
          >
            Voir tous les centres <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {CENTRES.map((c, i) => (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: easeOut, delay: i * 0.1 }}
              className="rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(0,35,102,0.12)]"
              data-testid={`centre-preview-${c.id}`}
            >
              <h3 className="font-display text-xl font-bold text-brand-blue">{c.ville}</h3>
              <div className="mt-3 flex flex-col items-start gap-1.5">
                {(Array.isArray(c.tag) ? c.tag : [c.tag]).map((t) => (
                  <span key={t} className="inline-block rounded-full bg-brand-red/10 px-3 py-1 text-xs font-medium text-brand-red">
                    {t}
                  </span>
                ))}
              </div>
              <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
                <li className="flex items-start gap-2">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" /> <span className="min-w-0 break-words">{c.adresse}</span>
                </li>
                {(c.phones || (c.telephone ? [{ num: c.telephone }] : [])).map((p) => (
                  <li key={p.num} className="flex items-start gap-2">
                    <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" /> <span className="min-w-0 break-words">{p.num}{p.label ? ` — ${p.label}` : ""}</span>
                  </li>
                ))}
                {(c.emails || (c.email ? [{ addr: c.email }] : [])).map((m) => (
                  <li key={m.addr} className="flex items-start gap-2">
                    <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" /> <span className="min-w-0 break-words">{m.addr}{m.label ? ` — ${m.label}` : ""}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
